import {
  adminAndIndependentRoles,
  AuthState,
  hasFrontendAccessWithRoleForOrganization,
  hasRole,
  Roles
} from '@efacity/common';
import { List } from '@mui/material';
import { ReactElement } from 'react';
import { getNavigationItems, getNavigationItemsBase, NavigationItem } from './leftNavigationHelpers';

export interface LeftNavigationItemsProps {
  authState: AuthState;
  currentOrgId: string | undefined;
  enrollmentRequired: boolean;
  renderNavigationItem: (navigationItem: NavigationItem, key: string) => ReactElement;
}

export function LeftNavigationItems({
  authState,
  currentOrgId,
  enrollmentRequired,
  renderNavigationItem
}: LeftNavigationItemsProps) {
  const baseNavigationItems = getNavigationItemsBase({
    allowedCreateActivity: authState.extraAuthInfo.center.allowedCreateActivity,
    allowedCreateSession: hasFrontendAccessWithRoleForOrganization(
      currentOrgId,
      adminAndIndependentRoles,
      authState?.user?.adminAccesses || []
    ),
    enrollmentRequired: enrollmentRequired,
    userId: authState.user._id,
    currentOrgId: currentOrgId,
    isSiteAdmin: hasRole(authState.user?.roles, Roles.SiteAdmin)
  });

  const leftNavigationItems = getNavigationItems(
    baseNavigationItems,
    currentOrgId,
    authState.user.adminAccesses || [],
    authState.user.roles
  );

  return (
    <List sx={{ px: 1 }}>
      {leftNavigationItems.map((navigationItem, index) => {
        return renderNavigationItem(navigationItem, `${index}`);
      })}
    </List>
  );
}
